var FormWithConsent;
(function (FormWithConsent) {
  FormWithConsent["Contact"] = "contactForm";
  FormWithConsent["Register"] = "registerForm";
  FormWithConsent["Checkout"] = "checkoutForm";
  FormWithConsent["Address"] = "addressForm";
  FormWithConsent["ProductAvailability"] = "productAvailabilityForm";
})(FormWithConsent || (FormWithConsent = {}));
export { FormWithConsent };